import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/partial/loader/loader.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PageErrorComponent } from 'src/app/components/partial/page-error/page-error.component';
import { BannerSliderComponent } from 'src/app/components/partial/banner-slider/banner-slider.component';
import { WhatsappFixedComponent } from 'src/app/components/partial/whatsapp-fixed/whatsapp-fixed.component';

@NgModule({
  declarations: [
    LoaderComponent,
    PageErrorComponent,
    BannerSliderComponent,
    WhatsappFixedComponent
  ],
  exports: [
    LoaderComponent,
    PageErrorComponent,
    BannerSliderComponent,
    WhatsappFixedComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule
  ]
})
export class PartialModule{}
